
class SystemApi {

    constructor(jsonApi) {
        this.jsonApi = jsonApi;
    }

    getConfig(successFunction, errorFunction = null) {
        const path = 'admin/config.php';
        this.jsonApi.get(path,
            (data) => {
                successFunction(data.data);
            },
            errorFunction);
    }

}

export default SystemApi;